import axios, { AxiosResponse } from "axios";
import useAuthHeaders from "hooks/useAuthHeader";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import { useQuery } from "react-query";
import { AllOrderResponse } from "types/order-all";

export interface UseQueueOrderParams {
    page?: string;
    per_page?: string;
    shipping_date?: string;
}

interface GetAllOrderQueue extends AxiosResponse {
    data: AllOrderResponse
}

const useQueueOrder = (params: UseQueueOrderParams) => {
    const signOut = useSignOut();
    const headers = useAuthHeaders();

    const queryParams = new URLSearchParams(params as unknown as Record<string, string>).toString();

    return useQuery<unknown, unknown, GetAllOrderQueue>({
        queryKey: ['get-queue-orders', queryParams],
        queryFn: async () => {
            try {
                return await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/queue/order?${queryParams}`, { headers })
            } catch (err) {
                console.error(err);
                if (err?.response?.status === 401) signOut();
            }
        },
    })
}

export default useQueueOrder;